import { TextField } from '@mui/material';
import styled from 'styled-components';

export const TextFieldStato = styled(TextField)`
  fieldset {
    border-radius: 17px;
  }
`;
